import React from "react";
import {
  Box,
  TextField,
  FormControl,
  InputLabel,
  Select,
  MenuItem,
  FormControlLabel,
  Switch,
  Typography,
  InputAdornment,
} from "@mui/material";
import { Search } from "@mui/icons-material";
import { SPACING } from "../../theme/constants";

/**
 * Site filters component with search, status, environment, and deleted toggle
 */
const SiteFilters = ({
  searchQuery,
  onSearchChange,
  filterStatus,
  onStatusChange,
  filterEnvironment,
  onEnvironmentChange,
  showDeleted,
  onShowDeletedChange,
  totalCount,
  visibleCount,
}) => {
  return (
    <Box
      sx={{
        mb: SPACING.lg,
        p: 2,
        border: "1px solid",
        borderColor: "divider",
        borderRadius: 2,
        bgcolor: "background.paper",
      }}
    >
      <Box
        sx={{
          display: "grid",
          gridTemplateColumns: "repeat(auto-fit, minmax(220px, 1fr))",
          gap: SPACING.sm,
          alignItems: "center",
        }}
      >
        {/* Search Field */}
        <TextField
          placeholder="Search sites..."
          value={searchQuery}
          onChange={(e) => onSearchChange(e.target.value)}
          size="small"
          InputProps={{
            startAdornment: (
              <InputAdornment position="start">
                <Search color="action" />
              </InputAdornment>
            ),
          }}
        />

        {/* Status Filter */}
        <FormControl size="small">
          <InputLabel>Status</InputLabel>
          <Select
            value={filterStatus}
            label="Status"
            onChange={(e) => onStatusChange(e.target.value)}
          >
            <MenuItem value="">All Statuses</MenuItem>
            <MenuItem value="ACTIVE">Active</MenuItem>
            <MenuItem value="PENDING">Pending</MenuItem>
            <MenuItem value="SUSPENDED">Suspended</MenuItem>
            <MenuItem value="MAINTENANCE">Maintenance</MenuItem>
          </Select>
        </FormControl>

        {/* Environment Filter */}
        <FormControl size="small">
          <InputLabel>Environment</InputLabel>
          <Select
            value={filterEnvironment}
            label="Environment"
            onChange={(e) => onEnvironmentChange(e.target.value)}
          >
            <MenuItem value="">All Environments</MenuItem>
            <MenuItem value="SANDBOX">Sandbox</MenuItem>
            <MenuItem value="STAGING">Staging</MenuItem>
            <MenuItem value="PRODUCTION">Production</MenuItem>
          </Select>
        </FormControl>

        {/* Show Deleted Toggle */}
        <Box
          sx={{
            display: "flex",
            alignItems: "center",
            border: "1px solid",
            borderColor: "divider",
            borderRadius: 1,
            bgcolor: "background.paper",
            width: "100%",
            py: 0.5,
          }}
        >
          <FormControlLabel
            control={
              <Switch
                checked={showDeleted}
                onChange={(e) => onShowDeletedChange(e.target.checked)}
                color="primary"
              />
            }
            label="Show Deleted Sites"
            sx={{ ml: 2 }}
          />
        </Box>

        {/* Count Display */}
        <Typography
          variant="body2"
          color="text.secondary"
          sx={{
            width: "100%",
            justifySelf: "stretch",
            textAlign: "left",
            px: 2,
            py: 1,
            border: "1px solid",
            borderColor: "divider",
            borderRadius: 1,
            bgcolor: "background.paper",
          }}
        >
          {visibleCount} of {totalCount} sites
        </Typography>
      </Box>
    </Box>
  );
};

export default SiteFilters;
